import { useEffect, useState } from "react";
import { api } from "@/api";
import { LayoutAutenticado } from "@/componentes/LayoutAutenticado";

const TIPOS = [
  "", "LOGIN", "LOGOUT", "CRIACAO_PALPITE", "EDICAO_PALPITE", "LANCAMENTO_RESULTADO",
  "ALTERACAO_RESULTADO", "ALTERACAO_PAGAMENTO", "ALTERACAO_USUARIO", "ACEITE_REGULAMENTO", "ACAO_ADMINISTRATIVA",
];

export default function LogsSistema() {
  const [logs, setLogs] = useState([]);
  const [tipo, setTipo] = useState("");

  useEffect(() => {
    (async () => {
      const { data } = await api.get("/logs", { params: tipo ? { tipo, limit: 200 } : { limit: 200 } });
      setLogs(data);
    })();
  }, [tipo]);

  return (
    <LayoutAutenticado>
      <div data-testid="pagina-logs">
        <div className="mb-6 flex flex-wrap items-end justify-between gap-4">
          <div>
            <div className="text-xs font-bold uppercase tracking-[0.3em] text-amarelobrasil">Segurança</div>
            <h1 className="font-heading text-4xl font-bold uppercase mt-1">Logs do Sistema</h1>
          </div>
          <select value={tipo} onChange={(e) => setTipo(e.target.value)} className="surface-card px-4 py-2.5 rounded-md text-sm border border-white/10" data-testid="select-tipo-log">
            {TIPOS.map((t) => <option key={t} value={t}>{t || "Todos"}</option>)}
          </select>
        </div>

        <div className="surface-card rounded-2xl overflow-x-auto">
          <table className="w-full text-sm">
            <thead className="bg-white/5 text-[10px] uppercase tracking-widest text-white/50 font-bold">
              <tr>
                <th className="px-4 py-3 text-left">Data</th>
                <th className="px-4 py-3 text-left">Tipo</th>
                <th className="px-4 py-3 text-left">Descrição</th>
                <th className="px-4 py-3 text-left">IP</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-white/5">
              {logs.map((l) => (
                <tr key={l.id}>
                  <td className="px-4 py-3 text-white/60 font-mono text-xs">{new Date(l.criadoEm).toLocaleString("pt-BR")}</td>
                  <td className="px-4 py-3 text-[10px] font-bold uppercase tracking-widest text-amarelobrasil">{l.tipoLog}</td>
                  <td className="px-4 py-3">{l.descricao}</td>
                  <td className="px-4 py-3 text-white/40 font-mono text-xs">{l.ip || "—"}</td>
                </tr>
              ))}
              {logs.length === 0 && (
                <tr><td colSpan={4} className="px-4 py-8 text-center text-white/40">Nenhum log encontrado.</td></tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </LayoutAutenticado>
  );
}
